import { Outlet, useNavigate, NavLink } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { useAuth } from "../auth/AuthProvider";
import { bootstrapFirstAdmin } from "../api/functions";

export function CustomerLayout() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut(auth);
    navigate("/login");
  };

  // One-time bootstrap: only works while there's no admin in the project.
  // After the first successful use, the function refuses subsequent calls,
  // so leaving this button visible is safe.
  const handleBootstrap = async () => {
    if (!confirm("Promote this account to admin? Only works during initial setup.")) return;
    try {
      const r = await bootstrapFirstAdmin();
      alert(r.message);
      await signOut(auth);
      navigate("/login");
    } catch (err) {
      const msg = (err as { message?: string }).message ?? "Bootstrap failed";
      alert(msg);
    }
  };

  const navLinkClass = ({ isActive }: { isActive: boolean }) =>
    "px-3 py-1.5 rounded-md text-sm font-medium transition " +
    (isActive
      ? "bg-indigo-50 text-indigo-700"
      : "text-slate-600 hover:text-slate-900");

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-6 h-14 flex items-center justify-between">
          <div className="font-semibold text-slate-800">Dinflow Dashboard</div>
          <div className="flex items-center gap-4 text-sm text-slate-600">
            <span>{user?.email}</span>
            <button onClick={handleBootstrap} className="text-xs text-slate-400 hover:text-slate-600">
              Bootstrap admin
            </button>
            <button onClick={handleSignOut} className="text-indigo-600 hover:underline">Sign out</button>
          </div>
        </div>
        <nav className="max-w-4xl mx-auto px-6 pb-2 flex gap-1">
          <NavLink to="/customer" end className={navLinkClass}>Reports</NavLink>
          <NavLink to="/customer/licenses" className={navLinkClass}>My Licenses</NavLink>
        </nav>
      </header>
      <main className="max-w-4xl mx-auto px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
